"use client";

import { BadgeGuidepost } from "@faire/retailer-visitor-shared/components/ProductBadge/BadgeGuidepost";
import { TopBadgesProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadgesProps";
import { useGetProductTileClickImpressions } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import * as React from "react";

export const LoggedOutTopBadges: React.FC<{ data: TopBadgesProps }> = ({
  data,
}) => {
  const { recordProductBadgeViewEvent } = useGetProductTileClickImpressions({
    token: data.productToken,
    badgeList: data.badgeList,
  });

  const badgeGuidepostRef = useDoActionWhenVisible(recordProductBadgeViewEvent);

  if (data.hideBadge) {
    return null;
  }

  const tileBadge = data.topBadge ? (
    <div ref={badgeGuidepostRef} key="tile-badge">
      <BadgeGuidepost badge={data.topBadge} productToken={data.productToken} />
    </div>
  ) : null;

  if (tileBadge) {
    return (
      <>
        <div
          className="absolute top-0 z-2 flex w-full flex-row items-start justify-between p-1"
          key="top-badges-container"
        >
          <div className="max-w-8/10 min-w-0 p-1">
            <div className="max-w-full">{tileBadge}</div>
          </div>
        </div>
      </>
    );
  }
  return null;
};
